module.exports = __webpack_public_path__ + "static/media/digital.324c54a5.png";